// domain/constants/workflowType.js

import { MEASUREMENT_METRIC } from './measurementMetric';

/**
 * The metric each mastery workflow type evaluates.
 *
 * A workflow only applies to a target measured by its metric: the target card shows any other as
 * empty. Mirrors `metric` on `workflowTypes` in `boot/globals`, which a context may not import.
 * `manual` evaluates nothing, so it fits every target.
 *
 * @domainObject value-object
 */
export const WORKFLOW_TYPE_METRIC = {
  accuracyIncrease: MEASUREMENT_METRIC.PERCENT_CORRECT,
  accuracyReduction: MEASUREMENT_METRIC.PERCENT_CORRECT,
  frequencyIncrease: MEASUREMENT_METRIC.FREQUENCY,
  frequencyReduction: MEASUREMENT_METRIC.FREQUENCY,
  ratePerHourIncrease: MEASUREMENT_METRIC.RATE_PER_HOUR,
  ratePerHourReduction: MEASUREMENT_METRIC.RATE_PER_HOUR,
  ratePerMinuteIncrease: MEASUREMENT_METRIC.RATE_PER_MINUTE,
  ratePerMinuteReduction: MEASUREMENT_METRIC.RATE_PER_MINUTE,
  totalDurationIncrease: MEASUREMENT_METRIC.TOTAL_DURATION,
  totalDurationReduction: MEASUREMENT_METRIC.TOTAL_DURATION,
  minDurationIncrease: MEASUREMENT_METRIC.MIN_DURATION,
  minDurationReduction: MEASUREMENT_METRIC.MIN_DURATION,
  maxDurationIncrease: MEASUREMENT_METRIC.MAX_DURATION,
  maxDurationReduction: MEASUREMENT_METRIC.MAX_DURATION,
  avgDurationIncrease: MEASUREMENT_METRIC.AVG_DURATION,
  avgDurationReduction: MEASUREMENT_METRIC.AVG_DURATION,
  manual: null,
};

/**
 * @param {string} [type] a workflow document's `type`
 * @returns {string|null|undefined} the metric it evaluates; null for `manual`, undefined for a type
 *   this table does not know
 */
export function workflowTypeMetric(type) {
  // A workflow with no type predates the field, and the target card reads it as accuracy.
  return WORKFLOW_TYPE_METRIC[type || 'accuracyIncrease'];
} // workflowTypeMetric()
